import { render, staticRenderFns } from "./getRuleContent.vue?vue&type=template&id=401a0b1f&scoped=true&"
import script from "./getRuleContent.vue?vue&type=script&lang=js&"
export * from "./getRuleContent.vue?vue&type=script&lang=js&"
import style0 from "./getRuleContent.vue?vue&type=style&index=0&id=401a0b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a0b1f",
  null
  
)

export default component.exports